import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from 'scenes/App';
import { loadAnalyticsWrapper } from 'services/analytics';
import store from 'store';
import * as Sentry from '@sentry/react';
import { environment as env } from 'services/environment';
import * as envs from './services/environment/envs';
import { DownForMaintenanceWrapper } from './components/DownForMaintenanceWrapper';
import { FeatureFlagProvider } from './components/FeatureFlagProvider';
import AppProvider from '@atlaskit/app-provider';

const BASE_URL = process.env.NODE_ENV === 'production' ? '/main' : '/';
const environment = env().name;
const release = process.env.REACT_APP_GIT_COMMIT_ID;

declare global {
  interface Window {
    loadAnalyticsWrapper: () => void;
  }
}

window.loadAnalyticsWrapper = loadAnalyticsWrapper;

const container = document.getElementById('com-atlassian-preferences-center')!;
const root = createRoot(container);
root.render(
  <AppProvider defaultColorMode={'light'}>
    <FeatureFlagProvider>
      <Provider store={store}>
        <Router basename={BASE_URL}>
          <DownForMaintenanceWrapper>
            <App />
          </DownForMaintenanceWrapper>
        </Router>
      </Provider>
    </FeatureFlagProvider>
  </AppProvider>,
);

// Redirect to "/main" if navigating to "/"
if (BASE_URL !== '/' && window.location.pathname === '/') {
  window.location.replace(BASE_URL);
}

if (environment !== envs.LOCAL) {
  Sentry.init({
    dsn: 'https://76f2b7bbaa484ed582798df767d23325@o55978.ingest.sentry.io/4504554119102464',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: environment,
    release: release,
    ignoreErrors: [
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
      'Network request failed',
      'NetworkError',
    ],
  });
}
